<template>
  <modal v-model="show" max-width="1024px" hide-actions no-padding>
    <div class="img-container">
      <img src="@/assets/transpress-3PL-services.jpg">
      <a href="mailto:3PL@transpress.bg?subject=Vote"></a>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/Modal.vue";
export default {
  components: {
    Modal
  },
  props: ['value'],
  data() {
    return {
      show: this.value
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('input', val);
    }
  }
}
</script>

<style scoped>
.img-container {
  position: relative;
  line-height: 0;
}
.img-container > img {
  max-width: 100%;
  max-height: 100%;
}
.img-container > a {
  position: absolute;
  background-color: transparent;
  width: 16%;
  height: 8%;
  bottom: 3%;
  left: 39%;
}
</style>